import { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";

import HeaderClientes from "components/_refactor/headers/clients.js";

import TableCatalogoProdutos from "./components/table-catalogo-produtos";
import FilterCard from "components/_refactor/filter-card";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import InputText from "components/_refactor/text/input";

export default function VisualizarCatalogoProdutos() {
  const snackbar = useSnackbar();

  const [productsList, setProductsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [customFilters, setCustomFilters] = useState(null);
  const [productInfo, setProductInfo] = useState();
  const [selectedLine, setSelectedLine] = useState();
  const [selectedCollection, setSelectedCollection] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedPhotoType, setSelectedPhotoType] = useState();

  function truncateText(text, maxLength) {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  const handleClearFilters = () => {
    setProductInfo({ name: "", id: "" });
    setSelectedLine({ name: "", id: "" });
    setSelectedCollection({ name: "", id: "" });
    setSelectedType({ name: "", id: "" });
    setSelectedPhotoType({ name: "", id: "" });
    setProductsList([]);
  };

  const handleSearchProducts = async () => {
    try {
      setIsLoading(true);

      const params =
        "?" +
        (productInfo ? `&filter=${productInfo.name}` : "") +
        (selectedLine ? `&linha=${selectedLine.name}` : "") +
        (selectedCollection ? `&colecao=${selectedCollection.name}` : "") +
        (selectedType ? `&tipoProduto=${selectedType.name}` : "") +
        (selectedPhotoType ? `&categoriaFoto=${selectedPhotoType.name}` : "");

      const response = await Api.get(
        "list-product-catalog",
        "trocasDevolucoes",
        params,
        true
      );

      const formattedResults = response.Result.ListaProdutos?.map((item) => {
        const photos = item?.Urls?.filter((url) => url !== "").map(
          (url, i) => ({
            fileName: url.split("/").pop().split(".")[0],
            id: item.IdMidias[i],
            productId: item.IdProduto,
            ean: item.Ean,
            url,
          })
        );

        return {
          code: item.IdProduto,
          description: truncateText(item.DescricaoProduto, 40),
          line: item.Linha,
          collection: item.Colecao,
          type: item.TipoProduto,
          photos,
        };
      });

      console.log(formattedResults);

      setProductsList(
        formattedResults.filter((item) => item.photos.length > 0)
      );
    } catch (error) {
      snackbar.showMessage(error, { severity: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getFilters = async () => {
      try {
        setIsLoadingFilters(true);

        const response = await Api.get(
          "list-catalog",
          "trocasDevolucoes",
          "?page=0",
          true
        );

        setCustomFilters(response.Result);

        setIsLoadingFilters(false);
      } catch (error) {
        snackbar.showMessage(error, { severity: "error" });
      }
    };

    getFilters();
    handleSearchProducts();
  }, []);

  return (
    <>
      <HeaderClientes
        section="Visualzar catálogo de fotos de produtos"
        subsection="Catálogo de Produtos"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearchProducts}
          disabled={isLoading}
          searching={isLoading}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xl={12} xs={12}>
            <InputText
              label="Código/Descrição do produto (Ciclo)"
              value={productInfo}
              onChange={(e) => {
                setProductInfo(e.target.value);
              }}
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Linha"
              onChange={(e) => setSelectedLine(e)}
              value={selectedLine}
              options={customFilters?.Linha?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Coleção/Lançamento"
              onChange={(e) => setSelectedCollection(e)}
              value={selectedCollection}
              options={customFilters?.Colecao?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Tipo de produto"
              onChange={(e) => setSelectedType(e)}
              value={selectedType}
              options={customFilters?.TipoProduto?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Categoria da foto"
              onChange={(e) => setSelectedPhotoType(e)}
              value={selectedPhotoType}
              options={customFilters?.CategoriaFoto?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
        </FilterCard>

        <Grid item xs={12}>
          <TableCatalogoProdutos data={productsList} />
        </Grid>
      </Container>
    </>
  );
}
